import React from 'react'

// css
import 'assets/style/common.scss'

import { ListTitle, InfoList, Image, Tag, MenuList } from 'components'

import { useCrtDtlRtrv, useCrtDtlMenuList } from 'api/menucrte/menucrtcarte-fetch'

import { useState } from 'react'
import { useEffect } from 'react'
import { getHashTag, isEmptyString } from 'utils/common-util'
import { combineImages } from 'utils/image-mark'
import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'

// 식단
function Carte({ info }) {
  const userInfo = useRecoilValue(userInfoState)
  const [isInit, setIsInit] = useState(false)
  const { isSuccess, data, remove } = useCrtDtlRtrv(info, isInit)
  const { isSuccess: isSuccess2, data: data2, remove: remove2 } = useCrtDtlMenuList(info, isInit)
  const [imgUrl, setImgUrl] = useState('')

  useEffect(() => {
    setIsInit(true)
    return () => {
      remove()
      remove2()
    }
  }, [])

  useEffect(() => {
    const urlYn = data?.imgUrl || ''
    if (isEmptyString(urlYn)) return

    let newUrl = ''
    if (data?.ccFrsCrtYn === 'Y') {
      // 프레시식단인경우
      newUrl = process.env.REACT_APP_MENU_IMAGE_URL + '/' + urlYn + '?cTTL=' + process.env.REACT_APP_MENU_IMAGE_CTTL
    } else if (data?.pmealYn === 'Y') {
      const replaceUrl =
        urlYn?.replace(
          /https:\/\/cjfw-prd-nb-fsapp-s3\.s3\.ap-northeast-2\.amazonaws\.com|https:\/\/fsmealimageprd\.ifresh\.co\.kr/g,
          '',
        ) || ''

      // 사이트식단인경우
      setImgUrl(
        process.env.REACT_APP_MENU_FRESH_MEAL_IMAGE_URL + replaceUrl + '?cTTL=' + process.env.REACT_APP_MENU_IMAGE_CTTL,
      )
      return
    } else {
      newUrl = process.env.REACT_APP_PRODUCT_MENU_IMAGE_URL + urlYn + '?cTTL=' + process.env.REACT_APP_MENU_IMAGE_CTTL
    }

    const run = async () => {
      if (data?.aiImgYn === 'Y') {
        try {
          const watermarkUrl = await combineImages(newUrl, 'Y', true)
          if (watermarkUrl) {
            setImgUrl(watermarkUrl)
          }
        } catch (e) {
          setImgUrl(newUrl)
        }
      } else {
        setImgUrl(newUrl)
      }
    }

    run()

    return () => {
      setImgUrl('')
    }
  }, [data])

  return (
    <main>
      <section>
        {isSuccess && (
          <div className="wrapper">
            <div className="py16">
              <Image src={imgUrl || ''} alt="" className="thumb round-4" cTTL={false} />
            </div>
            <ListTitle title="식단기본정보" className="border-black" />
            <InfoList
              className="mt12"
              data={
                !userInfo.phbtUseSiteList?.includes(data.siteId) ||
                (userInfo.phbtUseUser === true &&
                  userInfo.phbtUseSiteList?.includes(data.siteId) &&
                  userInfo.phbtUseUserShpt === data.siteId?.substring(0, 3))
                  ? [
                      {
                        id: 1,
                        title: '표시',
                        data: <Tag className="mb0" data={getHashTag(data)} />,
                      },
                      { id: 2, title: '식단코드', data: data.poolCrtId },
                      // { id: 3, title: '식단명', data: data.poolCrtNm },
                      { id: 4, title: '점포가', data: `${data.shopPrce?.toLocaleString()}원` },
                    ]
                  : [
                      {
                        id: 1,
                        title: '표시',
                        data: <Tag className="mb0" data={getHashTag(data)} />,
                      },
                      { id: 2, title: '식단코드', data: data.poolCrtId },
                    ]
              }
            />
          </div>
        )}
      </section>
      <MenuList
        className="wrapper mt8"
        isStore={false}
        datas={data2?.map(({ menuId, menuNm, shopPrce, imgUrl, aiImgYn, siteId }) => ({
          src: imgUrl,
          menuId: menuId,
          menuNm: menuNm,
          trfUnprc: shopPrce,
          aiImgYn,
          siteId,
          moveYn: false,
        }))}
      />
    </main>
  )
}

export default Carte
